<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/zS6xIM/9781847675644_cover_bbeb.jpg?1693505163963" alt="This image is the cover for the book Listen to the Voice, Canongate Classics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Listen to the Voice, Canongate Classics
      </h1>
      <p class="bookDescription body article font2">
        <p><b>These eighteen short stories by the Scottish poet and author of <i>Consider the Lilies </i>“focus on the ambiguities of the inner voice . . . with moments of searing emotion” (<i>Independent on Sunday</i>, UK).</b><br/><br/> This collection of the best of Iain Crichton Smith’s short fiction beckons us to listen, not only to the voice of this impeccable author, but to the many voices, both public and private, that he conjures in his characters. Ranging from inner promptings towards self-discovery to the unconscious comedy of everyday speech and even the rantings of near madness, these stories display the peaks of Smith’s wry, surrealistic humor, and his confessional mode in examining the past.<br/><br/> The longer stories, illustrative of Smith’s novels, are represented by ‘Murdo’ and the seminal ‘The Black and the Red’. There are also outstanding short pieces such as ‘Listen to the Voice’ and the poignant vignette, ‘The Dying’.<br/><br/> This edition of Listen to the Voice includes an introduction by Douglas Gifford.<br/><br/><b>“He has a dry pungent humor, a gift for comic invention and a welcome ability to laugh at himself and his background while making a serious point and taking us to conclusions that are anything but obvious.” —<i>The Scotsman</i>, UK</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Iain Crichton Smith, Douglas Gifford
      </h2>
      
      <p class="authorDescription body article">Iain Crichton Smith (1928-98) was born in Glasgow and raised by his widowed mother on the Isle of Lewis before going to Aberdeen to attend university. As a sensitive and complex poet in both English and his native Gaelic, he has published many collctions of verse, from The Long RIver in 1955 to A Life in 1986. The latter volume looks back over his years in Lewis and Aberdeen, to remember a spell of National Service in the fifties, leading to his work as an English teacher in Clydebank and Dumbarton, and from 1955 at the High School in Oban until his retirement in 1977. He has been recipient of a number of literary prizes, Scottish Arts Council Awards and fellowships, as well as the Queen's Jubilee Medal and, in 1980, an OBE.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Canongate
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?68c6f79e